// WHCA logo lockup — periwinkle circle + sage leaf. This is the prototype's
// placeholder mark; drop in the real Wellington Health Care Alliance logo SVG
// here (topbar/login) when available.
export function Logo({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
  const d =
    size === 'lg'
      ? { circle: 40, leafW: 34, leafH: 23, mt: -4, ml: -5 }
      : { circle: 26, leafW: 22, leafH: 15, mt: -3, ml: -4 }

  return (
    <span className="inline-flex items-start" aria-hidden="true">
      <span
        style={{
          width: d.circle,
          height: d.circle,
          borderRadius: '50%',
          background: 'hsl(var(--primary))',
        }}
      />
      <span
        style={{
          width: d.leafW,
          height: d.leafH,
          background: 'var(--sage)',
          borderRadius: '3px 90% 3px 90%',
          transform: 'rotate(-20deg)',
          marginTop: d.mt,
          marginLeft: d.ml,
        }}
      />
    </span>
  )
}
